var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-loading',{staticClass:"is-relative",staticStyle:{"height":"48px","background":"none"},attrs:{"active":_vm.active,"is-full-page":false,"animation":"none"}})}
var staticRenderFns = []

export { render, staticRenderFns }